import React from 'react';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import './contact_support.less';
import {Link} from 'react-router';
import ProfileNavBar from './profile_navbar/profile_navbar';
import './account.less';
import './legal.less';
import {data} from './legal_data';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../auth/auth_actions';
import LoggedinFooter from '../footer/loggedin_footer';
import cookies from '../util/cookie';

class LegalDetails extends React.Component {
  constructor(props) {
      super(props);
  }
  render(){
    return(
      <div className="legal-details-wrap">
        <div className="heading">
          Legal
        </div>
        <div className="content">
          <p>{this.props.legalData.para1.data}</p>
          <p>{this.props.legalData.para2.data}</p><br/>
          <p>{this.props.legalData.para3.data}</p><br/>
          <p>{this.props.legalData.para4.data}</p>
        </div>
      </div>
    )
  }
}
class Legal extends React.Component {
    constructor(props) {
        super(props);
        this.logout = this.logout.bind(this);
    }

    logout(){
      this.props.authActions.logout().always(() => {
          cookies.delete('_sd');
          document.location.href = '/';
      });
    }

    render() {
       const {props, state} = this;
       const {userData} = props.authState;
       let user = {
         name: '',
         imageUrl: '',
         isVerified: '',
         creditAmount: ''
       };

       if(props.authState) {
         user.name = userData.name;
         user.imageUrl = userData.profileImageUrl;
         user.isVerified = userData.isVerified;
         user.creditAmount = userData.creditAmount
       }
        return (
            <div className="account-details-wrap">
                <DashBoardHeader user={user} logout={this.logout} />
                <div className="account-header-wrap">
                    <div className="wrapper">
                        <h2 className="page-header account-page-header">Account</h2>
                    </div>
                </div>
                <div className="wrapper account-wrapper">
                <div className="profile-nav-bar-component">
                  <ProfileNavBar pathname={this.props.location.pathname} userData={user}/>
                </div>
                <div className="account-details-component">
                    <LegalDetails legalData = {data} />
                </div>
              </div>
              <LoggedinFooter />
            </div>
        )
    }
}

Legal = connect((state) => {
  return {
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch),
  }
})(Legal);

export default Legal;



// WEBPACK FOOTER //
// app/profile/legal.jsx